module.exports = __webpack_public_path__ + "static/media/creditcard.f29a1b1d.png";